"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/SolidRoad.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var SolidRoad = function SolidRoad(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "solid-icon",
    viewBox: "0 0 195.84 150.66"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Road Icon"), _react2.default.createElement("g", {
    className: "road",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "road-2",
    d: "M101.48 0q.24 6.25.51 12.49h-8.16q.29-6.24.53-12.49H74.64L35 150.66h53.31q.24-6.25.51-12.49H107l.51 12.49h53.34L121.21 0h-19.73zm-8.36 31.22h9.64L104.17 66H91.72l1.4-34.76zm-3.56 88.21L91 84.67h13.91l1.4 34.76H89.57z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M134.15 0h-6.72l50.26 150.66h18.15L134.15 0zM61.71 0L0 150.66h18.15L68.43 0h-6.72z",
    className: "outer",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  })));
};
exports.default = SolidRoad;